import { c as _c } from "react/compiler-runtime";
import type { Language, OnboardingSessionConfig } from '@onefootprint/request-types';
import type { BusinessBoKycData } from '@onefootprint/types';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import i18n from '../../config/initializers/i18next-test';
import Header from './header';
type IntroProps = {
  businessBoKycData?: BusinessBoKycData;
  onboardingConfig?: OnboardingSessionConfig;
  onClick: () => void;
};
const Intro = t0 => {
  const $ = _c(14);
  const {
    businessBoKycData,
    onboardingConfig,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.intro"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const language = i18n.language as Language;
  const copies = onboardingConfig?.copyData?.[language];
  let t2;
  if ($[1] !== businessBoKycData || $[2] !== copies || $[3] !== onboardingConfig) {
    t2 = <Header onboardingConfig={onboardingConfig} businessBoKycData={businessBoKycData} copies={copies} />;
    $[1] = businessBoKycData;
    $[2] = copies;
    $[3] = onboardingConfig;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== copies?.hostedCallToActionTitle || $[6] !== t) {
    t3 = copies?.hostedCallToActionTitle ?? t(_temp);
    $[5] = copies?.hostedCallToActionTitle;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onClick || $[9] !== t3) {
    t4 = <Button onClick={onClick} type="button" size="large" fullWidth={true}>{t3}</Button>;
    $[8] = onClick;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className="flex flex-col items-center justify-center gap-7 pt-8">{t2}{t4}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default Intro;
function _temp($) {
  return $.cta;
}